import {
  BotMonitorCheckError,
  BotMonitorQuery,
  BotMonitorSortBy,
  BotMonitorStatus,
} from "../interfaces/botMonitor"

export const BOT_MONITOR_STATUSES: readonly BotMonitorStatus[] = [
  "unverified",
  "active",
  "frozen",
  "gone",
]
export const BOT_MONITOR_SORT_FIELDS: readonly BotMonitorSortBy[] = [
  "blockedAt",
  "createdAt",
  "lastCheckAt",
  "username",
  "status",
]
export const BOT_MONITOR_CHECK_ERRORS: readonly BotMonitorCheckError[] = [
  "invalidUsername",
  "incompleteEvidence",
  "floodWait",
  "sessionDead",
  "network",
  "busy",
  "rateLimited",
  "leaseLost",
  "peerFlood",
  "rpc",
  "unknown",
]
export const BOT_MONITOR_STATUS_LABELS: Record<BotMonitorStatus, string> = {
  unverified: "Не проверен",
  active: "Активен",
  frozen: "Заморожен / бан",
  gone: "Недоступен",
}
export const BOT_MONITOR_DEFAULTS: Readonly<BotMonitorQuery> = {
  limit: 50,
  offset: 0,
  archived: false,
  sortBy: "blockedAt",
  order: "DESC",
}
